import { Hand, Suit, suits, Tile, ValidValue, validValues } from './types';

export const parseHandString = (hand: string): Hand => {
  const finalValues: Tile[] = [];
  let pendingValues: Tile[] = [];

  const splitHand = hand.split('');
  let isOpen = false;
  for (let i = 0; i < splitHand.length; i++) {
    const tile: Suit | ValidValue = splitHand[i];

    if (tile === '-') {
      isOpen = true;
    }

    if (suits.includes(tile as Suit)) {
      finalValues.push(
        ...pendingValues.map((pending) => ({
          ...pending,
          suit: tile as Suit,
          open: isOpen,
        })),
      );

      pendingValues = [];
    } else if (validValues.includes(tile as ValidValue)) {
      const uuid = Math.random().toString(36).slice(2);
      let newTile: Tile;
      if (tile === '0') {
        newTile = { id: uuid, value: '5', aka: true };
      } else {
        newTile = { id: uuid, value: tile as ValidValue };
      }

      if (splitHand[i + 1] === "'" || splitHand[i + 1] === '’') {
        newTile.modifier = 'rotated';
      } else if (splitHand[i + 1] === '"' || splitHand[i + 1] === '”') {
        newTile.modifier = 'stacked';
      }

      pendingValues.push({ ...newTile, open: isOpen });
    }
  }

  finalValues.push(...pendingValues);

  return finalValues;
};
